import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export function sliderBrands()  {
  const blocks = document.querySelectorAll('.blockBrands');
  if(blocks){

  blocks.forEach(block=>{
      new Splide(block, {

        pagination: false,
        arrows: false,
        padding: '0rem',
        drag: 'false',
        pauseOnHover: false,
        pauseOnFocus: false,
        type   : 'loop',
        perPage: 4,
        autoScroll: {
          speed: 2,
          pauseOnHover: false,
          pauseOnFocus: false,
          autoStart: true,

        },

        breakpoints: {
          1100: {
            perPage : 3,
            perMove : 1,
          },
          840: {
            perPage : 2,
            perMove : 1,
            pagination : false,
            padding: '2rem',
          },
          840: {
            perPage : 2,
            perMove : 1,
            pagination : false,
            padding: '3rem',
          }
        }
        }).mount({ AutoScroll });
  });
}
}